<template>
  <b-modal
      v-model="show"
      v-if="show"
      centered
      hide-footer
      title="بررسی پیام گزارش شده"
      :no-close-on-backdrop="true"
      size="md"
  >
    <b-overlay :show="loading" rounded spinner-small class="">
      <div class="mb-2">
        <p style="margin-bottom:5px">متن پیام</p>
        <div v-if="item.MessageText" class="border" style="padding: 10px">
          {{ item.MessageText }}
        </div>
        <p v-else class="text-muted text-center">پیام وجود ندارد</p>
      </div>
      <div v-if="file" class="mb-2">
        <p style="margin-bottom:5px">فایل</p>
        <div>
          <video
              v-if="file.Extension === 'mp4'"
              style="border-radius: 0.357rem;width: auto;max-height: 180px"
              controls
          >
            <source :src="file.Url">
          </video>
          <fm-file-preview v-else :file="file" style="border-radius: 8px" />
        </div>
      </div>
      <p style="margin-bottom:5px">گزارش دهندگان</p>
      <b-table :items="item.MessageReport" :fields="fields" />
      <v-select
          v-model="MessageReportStatus"
          label="title"
          :reduce="x => x.value"
          :options="[
              {value:0,title:'نقض قوانین'} ,
              {value:1,title:'بدون اشکال'},
              {value:2,title:'گزارش مجدد'},
              {value:3,title:'در حال بررسی'},
              ]"
      >
    <span
        slot="no-options"
        @click="$refs.select.open = false"
    >
      {{ $t('common.noOptions') }}
    </span>
      </v-select>
      <div class="mt-2" v-if="MessageReportStatus===0">
        <b-form-group>
          <b-form-checkbox
              v-model="DisableTerm"
              name="DisableTerm"
              :value="true"
              class="custom-control-danger"
          >
            رژیم غیرفعال شود
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
              v-model="DeleteUserMessages"
              name="DeleteUserMessages"
              :value="true"
              class="custom-control-danger"
          >
            همه پیام های کاربر حذف شود
          </b-form-checkbox>
        </b-form-group>
      </div>

      <b-form-group
          class="mt-2"
          label="توضیحات"
          label-for="Description"
      >
        <div class="form-label-group">
          <b-form-textarea
              id="Description"
              v-model="ReasonsDescrption"
              name="Description"
              autocomplete="off"
              rows="3"
              :disabled="!DisableTerm && !DeleteUserMessages"
          />
        </div>
      </b-form-group>
      <div class="text-center mt-3">
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            class="mr-1"
            variant="success"
            :disabled="loading"
            @click="changeStatus()"
        >
          ذخیره
        </b-button>
        <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="$emit('update:show', !show)"
        >
          انصراف
        </b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import FmFilePreview from "@/views/menu/file-manager/components/fmFilePreview.vue";

export default {
  name: "MessageReportItem",
  components: { FmFilePreview },
  props: {
    show: { type: Boolean, default: false },
    item: { type: Object, default: null },
  },
  data() {
    return {
      loading: false,
      fields: [
        {
          key: 'Name',
          label: 'گزارش دهنده',
        },
        {
          key: 'Description',
          label: 'دلایل قابل ذکر در تیکت',
        }
      ],
      DisableTerm: false,
      DeleteUserMessages: false,
      ReasonsDescrption: '',
      MessageReportStatus: null
    }
  },
  mounted() {
    this.MessageReportStatus = this.item.MessageReportStatus
  },
  computed: {
    editing() {
      return this.item && this.item.UserId
    },
    file() {
      if (!this.item.FileInfo) return
      return {
        Url: this.item.FileInfo.FilePath,
        Type: this.item.FileInfo.Type,
        Extension: this.item.FileInfo.FilePath.split('.').pop()
      }
    }
  },
  methods: {
    changeStatus() {
      this.loading = true
      let data = {
        MessageId: this.item.Id,
        MessageReportStatus: this.MessageReportStatus,
        DisableTerm: this.DisableTerm,
        DeleteUserMessages: this.DeleteUserMessages,
        ReasonsDescrption: this.ReasonsDescrption,
      }
      this.$http.post(this.$api.messenger.applyMessageReport, data).then(() => {
        this.loading = false
        this.$emit('update:show', !this.show)
        this.$emit('done')
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>